import { ServiceStatus, ServiceType } from 'types/api/services';

// Phase E Cycle 4 — values sourced from the canonical BE enum.
export const SERVICE_TYPES_VALUES = {
  radiology: ServiceType.Radiology,
  video_call: ServiceType.VideoCall,
  // department: ServiceType.Department,
  treatment: ServiceType.Treatment,
  find_doctor: ServiceType.FindDoctor
  // other: ServiceType.Other,
} as const satisfies Record<string, ServiceType>;

export const SERVICE_TYPES: Array<{ value: ServiceType; label: string }> = [
  { value: ServiceType.Radiology, label: 'Radiology' },
  { value: ServiceType.VideoCall, label: 'Video Call' },
  // { value: ServiceType.Department, label: 'Department' },
  { value: ServiceType.Treatment, label: 'Treatment' },
  { value: ServiceType.FindDoctor, label: 'Find Me a Doctor' }
  // { value: ServiceType.Other, label: 'Other' },
];

export const SERVICE_STATUSES: Array<{ value: ServiceStatus; label: string }> =
  [
    { value: ServiceStatus.Active, label: 'Active' },
    { value: ServiceStatus.Inactive, label: 'Inactive' }
  ];
